// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"cc3f993b","453":"ffe03649"}[chunkId] + ".chunk.js";
};